import { gsap } from "gsap";

export default {

	init() {
		console.log('init animation...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		const header = document.querySelector('.site-header > .header-inner');
		const hero = document.querySelector('.sh-block-wrapper.page-hero');
		const blocks = document.querySelectorAll('.sh-block-wrapper:not(.header, .jump-links)');
		const jumpNav = document.querySelector('.sh-block-wrapper.jump-links');

        Animation.header = header;
		Animation.hero = hero;
        Animation.blocks = blocks;
		Animation.jumpNav = jumpNav;

		Animation.welcomeIntro();

		if (jumpNav) {
			Animation.setJumpNavSize();
			Animation.handleJumpNavClick();
			window.addEventListener("resize", Animation.setJumpNavSize);
		}

		document.addEventListener("scroll", Animation.scrollWatcher);
	},

	welcomeIntro() {
		if(!document.querySelector('.welcome-intro')) {
			return;
		}

		const introElement = document.querySelector('.welcome-intro');

		const animationCallback = function() {
			document.body.classList.remove('is-intro-animating');
			introElement.remove();
		};

		document.body.classList.add('is-intro-animating');

		let tl = gsap.timeline({ defaults: { ease: "power2.inOut" } });
		tl.to('.welcome-blur', { x: '100vw', duration: 1.5 })
		  .to('.welcome-blur2', { x: '100vw', duration: 1.5 }, '<')
		  .to('.welcome-line', { height: '100%', duration: 0.7 }, '-=0.75')
		  .to('.welcome-waves', { opacity: 0, duration: 0.5 }, '-=0.5')
		  .to('.welcome-line', { opacity: 0, duration: 0.2 })
		  .to('.welcome-left', { x: '-=100%', duration: 1 }, '<')
		  .to('.welcome-right', { x: '+=100%', duration: 1 }, '<')
		  .call(animationCallback);
	},

	scrollWatcher(e) {
		if (Animation.header) {
			Animation.watchHeaderScroll();
		}

		if (Animation.jumpNav) {
			Animation.watchJumpNavScroll();
		}
	},

	watchHeaderScroll() {
		const elems = Array.from(Animation.blocks);
		let trigger = elems[0]; // default to first

		// Check for last overlapping block in view
		elems.forEach(function(elem) {
			if (Animation.elementOverlapsHeader(elem)) {
				trigger = elem;
			}
		});

		// Set colorway classes
		if (Animation.isColorwayDark(trigger) === true) {
			Animation.header.classList.remove('is-colorway-light');
			Animation.header.classList.add('is-colorway-dark');
		} else {
			Animation.header.classList.remove('is-colorway-dark');
			Animation.header.classList.add('is-colorway-light');
		}
	},

	watchJumpNavScroll() {
		const scrollY = window.scrollY;
		const navBounds = Animation.jumpNav.getBoundingClientRect();
		const trigger = Animation.header.offsetHeight;
		const threshold = Animation.hero.offsetHeight;
		const spacer = document.querySelector('.is-fixed-spacer');

		// Stick
		if (navBounds.top <= trigger) {
			Animation.jumpNav.classList.add('is-fixed');

			if (Animation.isJumpNavActive()) {
				spacer.classList.remove('hidden');
			}
		}

		// Unstick
		if (scrollY <= threshold - trigger) {
			Animation.jumpNav.classList.remove('is-fixed');
			spacer.classList.add('hidden');
		}
	},

	setJumpNavSize() {
		let spacer = document.querySelector('.is-fixed-spacer');

		if (!spacer) {
			let elem = document.createElement('div');
			elem.classList.add('is-fixed-spacer', 'hidden');
			Animation.jumpNav.parentNode.insertBefore(elem, Animation.jumpNav.nextSibling);
			spacer = document.querySelector('.is-fixed-spacer');
		}

		spacer.style.height = Animation.jumpNav.offsetHeight + 'px';
	},

	handleJumpNavClick() {
		const jumpLinks = Array.from(Animation.jumpNav.querySelectorAll('a'));
		jumpLinks.forEach(function(elem) {
			elem.addEventListener('click', function(e) {
				let href = elem.getAttribute('href');
				let target = document.getElementById(href.substring(1));

				if (!target) {
					return;
				}

				if (Animation.isJumpNavActive()) {
					let offset = Animation.jumpNav.offsetHeight + Animation.header.offsetHeight;
					target.style.scrollMarginTop = parseInt(offset + 10) + 'px';
				} else {
					target.style.scrollMarginTop = '';
				}
			});
		});
	},

	elementOverlapsHeader(elem) {
        const headerBounds = Animation.header.getBoundingClientRect();
        const elemBounds = elem.getBoundingClientRect();
		const elemStyle = getComputedStyle(elem);
		const elemMargin = parseInt(elemStyle.marginTop, 10) || 0;

        return !(headerBounds.bottom < (elemBounds.top - elemMargin) || headerBounds.top > (elemBounds.bottom + elemMargin));
    },

	isColorwayDark(elem) {
		// Whole page has dark background
		if (document.body.classList.contains('bg-raspberry-darkest')) {
			if (elem.classList.contains('footer')) {
				return false;
			}
			return true;
		}

		// Content block with dark backround is overlapping
		if (elem.classList.contains('bg-raspberry-darkest')) {
			return true;
		}

		// Page hero with dark background is overlapping
		if (elem.classList.contains('page-hero')) {
			let hero = elem.querySelector('.hero');
			if (hero && !hero.classList.contains('is-hero-light')) {
				return true;
			}
		}

		return false;
	},

	isJumpNavActive() {
		if (window.matchMedia('(min-width: 550px) and (max-width: 899px)').matches) {
			return true;
		}

		return false;
	},

}